<template>
  <div>
    <div class="divider" v-if="source.showDay">
      <div class="wrap" :style="{ backgroundColor: visualSettings.bodyBackgroundColor }">
        <span>{{formattedDate}}</span>
      </div>
      <div class="line"></div>
    </div>
    <Message 
      :text="source.text"
      :pinned="source.pinned"
      :attachment="source.attachment"
      :time="source.id"
      :sender="source.sender"
      :channelId="source.channelId"
      :isNotification="source.isNotification"
      :isCall="showCall"
    />
    <div class="gap" v-if="source.lastDay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Message from '@/components/Message';

export default {
  name: 'MessageVirtualItem',
  components: {
    Message
  }, 
  props: [
    'index',
    'source'
  ],
  computed: {
    ...mapGetters([
      'visualSettings'
    ]),
    showCall() {
      return this.source.lastDay && this.source.isCall;
    },
    formattedDate() {
      const date = this.$moment(this.$moment(this.source.id/10000).format('YYYY-MM-DD'));
      switch(this.diffDays(date)) {
        case 0:
          return 'Today';
        case 1:
          return 'Yesterday';
        default:
          return date.format('dddd, MMMM Do');
      }
    }
  },
  methods: {
    diffDays(date) {
      return this.$moment(new Date(),'HH').diff(date, 'days');
    }
  }
}
</script>

<style scoped lang="scss">
.gap {
  height: 5px;
}

.divider {
  position: relative;
  text-align: center;
  margin: -15px 0;

  .wrap {
    position: relative;
    display: inline-block;
    border-radius: 25.5px;
    background: #fff;
    padding: 9px 10px;
    z-index: 1;
  }

  span {
    font-size: 13.6px;
    line-height: 1.3;
    display: inline-block;
    height: 33px;
    box-sizing: border-box;
    color: rgba(0,0,0,0.3);
    border: 1px solid rgba(0,0,0,0.1);
    padding: 6px 14px;
    border-radius: 16.5px;
  }

  .line {
    position: absolute; 
    width: 100%;
    top: 50%;
    height: 1px;
    background: rgba(0,0,0,0.1);
  }
}
</style>
